<template>
  <div class="employeeRoster">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">字段名称</div>
            <el-input size="small" v-model="coluname" @keyup.enter.native="getImportFiledList()"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button type="success" plain size="small" @click="downLoadHandle">下载模板</el-button> -->
        <el-button type="warning" plain size="small" @click="addImportFiled">新增字段</el-button>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item>基础配置</el-breadcrumb-item>
          <el-breadcrumb-item>字段维护</el-breadcrumb-item>
          <el-breadcrumb-item>花名册导入字段维护</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="p_roster_table">
        <el-tab-pane label="字段维护" name="first"></el-tab-pane>
        <el-tab-pane label="花名册导入字段维护" name="second"></el-tab-pane>
      </el-tabs>
      <div class="employeeRosterTable">
        <el-table :data="tableData"  :max-height="tableHeight-180" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
          <el-table-column align="center" label="序号" prop="IntOrderId" width="100px"></el-table-column>
          <el-table-column label="字段名称" prop="StrColumName" min-width="20%"></el-table-column>
          <el-table-column label="字段类型" prop="StrColumnType" min-width="20%"></el-table-column>
          <el-table-column label="所属表格" prop="StrTableName" min-width="40%"></el-table-column>
          <!-- <el-table-column  label="字段关键字" prop="fieldKey" min-width="40%"></el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right" min-width="15%">
            <template slot-scope="scope">
              <button class="changeState" style="margin-right:10px" @click="editImportFiled(scope.row)">修改</button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
           @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="this.totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 新增 -->
      <el-dialog :visible.sync="dialogVisible" width="980px">
        <div class="diaTitle">新增字段</div>
        <div class="addimp">
          <div class="addFiledItem">
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              {{form.orderid}}
            </div>
          </div>
          <div class="addFiledItem">
            <div>字段名称：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-input size="small" v-model.trim="form.columname"></el-input>
            </div>
          </div>
          <div class="addFiledItem">
            <div>字段类型：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-input size="small" v-model="form.columtype" readonly></el-input>
            </div>
          </div>
          <div class="addFiledItem">
            <div>所属表格：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-select  v-model="form.selectedTab"  slot="prepend"  placeholder="请选择"  filterable  @change="selectSubordinate">
                <el-option
                  v-for="(item, index) in tableList"
                  :key="index"
                  :label="item.StrTableName"
                  :value="{value:item.StrTableId,label:item.StrTableName}"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="addFiledItem">
            <div>所属机构：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-select
                v-model="form.objName"
                slot="prepend"
                placeholder="请选择"
                filterable
                @change="selectObj"
              >
                <el-option
                  v-for="(item, index) in tableList"
                  :key="index"
                  :label="item.StrObjInstName"
                  :value="item.StrObjInstName"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="addimp" v-for="(item,index) in form.dynamicItem" :key="index">
          <div class="addFiledItem">
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              {{item.orderid}}
            </div>
          </div>
          <div class="addFiledItem">
            <div>字段名称：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-input size="small" v-model.trim="item.columname"></el-input>
            </div>
          </div>
          <div class="addFiledItem">
            <div>字段类型：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-input size="small" v-model="item.columtype" readonly></el-input>
            </div>
          </div>
          <!-- <div class="addFiledItem">
            <div>所属表格：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-select  v-model="item.selectedTab"  slot="prepend"  placeholder="请选择"  filterable  @change="selectSubordinate">
                <el-option
                  v-for="(item, index) in tableList"
                  :key="index"
                  :label="item.StrTableName"
                  :value="{value:item.StrTableId,label:item.StrTableName}"
                ></el-option>
              </el-select>
            </div>
          </div>  
          <div class="addFiledItem">
            <div>所属机构：</div>
            <div class="addFiledItemInput" style="margin:0 20px 0 0">
              <el-select
                v-model="item.objName"
                slot="prepend"
                placeholder="请选择"
                filterable
                @change="selectObj"
              >
                <el-option
                  v-for="(item, index) in tableList"
                  :key="index"
                  :label="item.StrObjInstName"
                  :value="item.StrObjInstName"
                ></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="delFiledItem"><i class="el-icon-delete" @click="deleteItem(item, index)"></i></div>
        </div>

        <button @click="addItem" class="changeState" type="primary">新增一行</button>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button
            class="search"
            @click="confirmAddField"
            style="margin-left:10px;font-weight:600"
          >确定</button>
        </span>
      </el-dialog>
      <!-- 修改 -->
      <el-dialog :visible.sync="dialogVisible2" width="500px">
        <div class="diaTitle">修改字段</div>
        <div class="storageArea">
          <div>序&nbsp;&nbsp;&nbsp;&nbsp;号&nbsp;&nbsp;&nbsp;&nbsp;  ：</div>
          <div class="storageInput" style="margin:0 20px 0 0">
            <el-input size="small" v-model="finfo.IntOrderId" readonly></el-input>
          </div>
        </div>
        <div class="storageArea">
          <div>字段名称：</div>
          <div class="storageInput" style="margin:0 20px 0 0">
            <el-input size="small" v-model.trim="finfo.StrColumName"></el-input>
          </div>
        </div>
        <div class="storageArea">
          <div>字段类型：</div>
          <div class="storageInput" style="margin:0 20px 0 0">
            <el-input size="small" v-model="finfo.StrColumnType" readonly></el-input>
          </div>
        </div>
        <div class="storageArea">
          <div>所属表格：</div>
          <div class="storageInput" style="margin:0 20px 0 0">
            <el-select
              v-model="finfo.StrTableName"
              slot="prepend"
              placeholder="请选择"
              filterable
              @change="selectSubordinate"
            >
              <el-option
                v-for="(item, index) in tableList"
                :key="index"
                :label="item.StrTableName"
                :value="{value:item.StrTableId,label:item.StrTableName}"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="storageArea">
          <div>所属机构：</div>
          <div class="storageInput" style="margin:0 20px 0 0">
            <el-select
              v-model="finfo.StrObjInstName"
              slot="prepend"
              placeholder="请选择"
              filterable
              @change="selectObj"
            >
              <el-option
                v-for="(item, index) in tableList"
                :key="index"
                :label="item.StrObjInstName"
                :value="item.StrObjInstName"
              ></el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible2=false">取消</button>
          <button  class="search"  style="margin-left:10px;font-weight:600"  @click="confirmEdit()">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FUN from "../../fun";
import xz from "../../common";
export default {
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight:0,
      listLoading:false,
      coluname:"",
      finfo:"",
      num:1,
      currpage:1,
      pagecount:10,
      pageSize:10,
      totalcount: null,
      //录入内容
      enterKey: "",
      inputValue: "",
      keyWord: "",
      currentPage3: 1,
      //定义关键字
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        columname: '',
        columtype: '文本',
        selectedTab: null,
        orderid:1,
        ischk:'0',
        chkfunc:"",
        isfixed:'0',
        dynamicItem: []
      },
      objName:'',
      columndata:[],
      tableList: "",
      tabId: "",
      tabName: "",
      tableData: [],
      //导入弹窗
      importDialog:false,
      ExcelSrc: {
        value: "",
        check: false,
        fileName: ""
      },
      //错误提醒
      errorTxt:'',
      //导入excel路径
      excelpath:'',
      // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'customList'
        },
        activeName:'second',
      //角色类型
      roleType: ''
    }
  },
  created() {
    this.roleType = localStorage.loginRoletype
    this.butQuery.roletype = localStorage.loginRoletype
    this.calHeight()
    this.getTabInfo()
    this.getImportFiledList()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
      console.log('height',this.tableHeight) 
    },
    //切换tab
    handleClick(tab, event) {
      if(tab.name == 'first'){
        this.$router.push({
          path: '/fieldMaintenance',
          query: {
            active:'first'
          }
        })
      }
    },
    getTabInfo() {
      const gdata = {
        pagecount: 10,
        currpage: 1,
        tablename: "",
        ctluserid: ""
      };
      xz.getTableData(gdata, Cookies.get("userid-b")).then(res => {
        // console.log("tab", res);
        this.tableList = res.data;
      });
    },
    getImportFiledList(){
      const data = {
        pagecount: this.pagecount,
        currpage: this.currpage,
        tablename: "",
        coluname: this.coluname,
        strisfixed:0
      };
      this.listLoading = true
      xz.getImportFiledInfo(data).then(res =>{
        if(res){
          this.tableData = res.data;
          this.totalcount = parseInt(res.totalcount);
          this.num = this.totalcount + 1 + 52;
        }else{
          this.tableData = []
        }
        this.listLoading = false
      })
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currpage = `${val}`;
      this.getImportFiledList();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pagecount = `${val}`;
        this.pageSize = parseInt(val);
        this.getImportFiledList();
    },
    addImportFiled() {
      this.dialogVisible = true;
      this.form.orderid = this.totalcount + 1 + 52;
    },
    editImportFiled(row) {
      this.finfo = row;
      // console.log('row',row)
      this.tabId = row.StrTableId,
      this.objName = row.StrObjInstName,
      this.dialogVisible2 = true;
    },
    // 下拉选择表格
    selectSubordinate(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      console.log("d", d);
      this.form.selectedTab = d.label;
    },
    selectObj(d) {
      this.objName = d;
      console.log("d", d);
    },
    addItem(){
      // var nuu = 1;
      this.form.dynamicItem.push({
        columname: '',
        columtype: '文本',
        orderid:'',
        ischk:'0',
        chkfunc:"",
        isfixed:'0',
      })
        var num2 = this.num;
      if(this.form.dynamicItem.length>0){
        this.form.dynamicItem.forEach(element => {
          num2++;
          element.orderid = num2;
      })
      }
      console.log('Q',this.form)
    },
    deleteItem (item, index) {
      // console.log('iy',item,index)
      this.form.dynamicItem.splice(index, 1)
    },
    // confirmAddField(){
    //   console.log('list',this.form)
    //   this.columndata =[{
    //       columname:this.form.columname,
    //       columtype:this.form.columtype,
    //       orderid:this.num,
    //       ischk:this.form.ischk,
    //       chkfunc:this.form.chkfunc,
    //       isfixed:this.form.isfixed
    //     }]
    //     var num2 = this.num;
    //   if(this.form.dynamicItem.length>0){
    //     this.form.dynamicItem.forEach(element => {
    //       num2++;
    //       element.orderid = num2;
    //     this.columndata.push(element)
    //   })}
    //   console.log('columndata',this.columndata,this.objName)
    // },
    //确认新增
    confirmAddField() {
      this.columndata =[{
          columname:this.form.columname,
          columtype:this.form.columtype,
          orderid:this.num,
          ischk:this.form.ischk,
          chkfunc:this.form.chkfunc,
          isfixed:this.form.isfixed
        }]
        var num2 = this.num;
      if(this.form.dynamicItem.length>0){
        this.form.dynamicItem.forEach(element => {
          num2++;
          element.orderid = num2;
          this.columndata.push(element)
      })
      }
      const odata = {
        tableid: this.tabId,
        objinstname: this.objName,
        columndata:this.columndata
      }
      xz.addImportFiled(odata).then(res => {
        console.log('aa',res)
        if(res.status == "ok"){
          this.$message({
          message: '新增字段成功',
          type: 'success'
        });
        this.getImportFiledList();
        this.form = {
        columname: '',
        columtype: '文本',
        selectedTab: null,
        orderid:this.totalcount,
        ischk:'0',
        chkfunc:"",
        isfixed:'0',
        dynamicItem: []
      }
        }else{
          // console.log('p',res)
          this.$message.error(res);
        }
         this.dialogVisible = false;
      })
    },
    //确认修改
    confirmEdit(){
      const clum = [{
          columname:this.finfo.StrColumName,
          columtype:this.finfo.StrColumnType,
          orderid:this.finfo.IntOrderId,
          columnid:this.finfo.StrColumId,
          ischk:0,
          isfixed:0
      }]
      const data = {
        tableid: this.tabId,
        objinstname: this.objName,
        columndata: clum
      }
      xz.addImportFiled(data).then(res => {
        if(res){
          if(res.status == 'ok'){
            this.$message({
              message: '修改字段成功',
              type: 'success'
            });
          }else{
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
        this.getImportFiledList();
        }else{
          this.$message.error('系统异常，请于管理员联系');
        }
         this.dialogVisible2 = false;
      })
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.p_roster_table.el-tabs{
  background-color: #fff;
}
.top-right {
  display: flex;
  align-items: center;
  margin-right: 16px;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.employeeRosterTable .el-table th > .cell {
  padding: 0;
}
.employeeRosterTable .el-table .cell {
  padding: 0;
}
.employeeRosterTable .el-table td {
  padding: 6px 0;
}
.employeeRosterTable .el-table th {
  padding: 10px 0;
}
.storageInput2 .el-input--small .el-input__inner {
  width: 598px;
  height: 32px;
}
.storageInput2 .el-input--small {
  width: 598px;
}
.storageArea .upload-demo {
  height: 32px !important;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.enterArea .el-textarea__inner {
  width: 598px;
  /* margin-left: 6px; */
  margin-bottom: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageInput .el-input__inner {
  height: 32px;
}
.storageInput .el-input__icon {
  line-height: 32px;
}

.addFiledItemInput .el-input--small .el-input__inner {
  width: 130px;
  height: 32px;
}
.addFiledItemInput .el-input--small {
  width: 130px;
}
.addFiledItemInput .el-input__inner {
  width: 130px;
  height: 32px;
}
.addFiledItemInput .el-input__icon {
  line-height: 32px;
}

.delFiledItem [class*=" el-icon-"], .delFiledItem [class^=el-icon-] {
  line-height: 56px;
}
</style>